<template>
  <div class>
    <Toast />

    <div class="card css-table" v-if="confirmation_page == 0">
      <DataTable
        :value="list_items"
        :loading="loading.filter"
        :rowHover="true"
        :selection.sync="selectedItems"
        :paginator="true"
        :rows="15"
      >
        <template #empty>Data tidak tersedia.</template>
        <template #loading
          >Mengambil data daftar cetak barang. Mohon tunggu.</template
        >
        <h5>
          <b>Cetak Barcode Sisa</b>
        </h5>
        <template #header>
          <div class="p-grid p-fluid p-mb-3">
            <div class="p-col-12 p-md-4">
              <div class="p-field">
                <label for="supplier">Supplier</label>
                <AutoComplete
                  id="supplier"
                  placeholder="Pilih Supplier"
                  :dropdown="true"
                  :multiple="false"
                  v-model="selected_supplier"
                  :suggestions="suppliers"
                  @complete="searchSupplier($event)"
                  @input="is_error.supplier = false"
                  field="code"
                >
                  <template #item="slotProps">
                    <div>{{ slotProps.item.name }}</div>
                    <div style="font-style: italic; font-size: 12px">
                      {{ slotProps.item.code }}
                    </div>
                  </template>
                </AutoComplete>
                <small class="p-error" v-if="is_error.supplier">{{
                  error_msg.supplier
                }}</small>
              </div>
            </div>

            <div class="p-col-12 p-md-4">
              <div class="p-field">
                <label for="code">Kode Barang</label>
                <InputText
                  id="code"
                  v-model="filter.mutation_code"
                  placeholder="Masukkan Kode Barang"
                />
              </div>
            </div>

            <div class="p-col-12 p-md-4">
              <div class="p-field">
                <label for="date">Tanggal Barcode</label>
                <Calendar
                  id="date"
                  v-model="filter.barcode_date"
                  placeholder="Pilih Tanggal"
                  :maxDate="today"
                  :manualInput="false"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                />
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
              <div class="p-field">
                <Button
                  label="Cari"
                  icon="pi pi-search"
                  class="p-button-primary w-full"
                  @click="filterCatalogue()"
                  :loading="loading.filter"
                />
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
              <div class="p-field">
                <Button
                  label="Reset"
                  icon="pi pi-refresh"
                  class="p-button-secondary w-full"
                  @click="onReset"
                />
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
              <div class="p-field">
                <Button
                  v-if="list_items.length != 0 && selectedItems.length != 0"
                  label="Cetak"
                  icon="pi pi-print"
                  class="p-button-primary w-full"
                  @click="printBarcode()"
                />
              </div>
            </div>
          </div>
        </template>

        <Column
          field="cat_no"
          header="No"
          headerStyle="width: 3em; text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            {{ list_items.indexOf(slotProps.data) + 1 }}
          </template>
        </Column>
        <Column
          header="Kode Barang"
          headerStyle="width: 12em; text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            <span> {{ slotProps.data.code }} </span>
          </template>
        </Column>
        <Column
          header="Supplier"
          headerStyle="width: 12em; text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            <span> {{ slotProps.data.sup_name }} </span>
          </template>
        </Column>
        <Column
          header="Nama Barang"
          headerStyle="text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            <span> {{ slotProps.data.name }} </span>
          </template>
        </Column>
        <Column
          header="Kelompok Barang"
          headerStyle="text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            <span> {{ slotProps.data.cat_name }} </span>
          </template>
        </Column>
        <Column
          header="Stok"
          headerStyle="width: 3em; text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            <span> {{ slotProps.data.stock }} </span>
          </template>
        </Column>
        <Column
          header="Harga"
          headerStyle="text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            <span>{{ slotProps.data.price | currency }}</span>
          </template>
        </Column>
        <Column
          header="Jumlah"
          headerStyle="text-align: center"
          bodyStyle="text-align: center; overflow: visible"
        >
          <template #body="slotProps">
            <InputText
              placeholder="0"
              style="width: 50%"
              v-model="slotProps.data.input_stok"
            />
          </template>
        </Column>
        <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      </DataTable>

      <Dialog
        :visible.sync="print_dialog"
        :style="{ width: '90vw', maxWidth: '1000px' }"
        header="Konfirmasi Cetak Barcode"
        :modal="true"
        class="p-fluid"
      >
        <div class="confirmation-content">
          <div class="p-mb-3">
            <i class="pi pi-print p-mr-3" style="font-size: 1rem" />
            <span
              >Apakah Anda yakin ingin mencetak barcode untuk item yang
              dipilih?</span
            >
          </div>

          <DataTable
            :value="selectedItems"
            :scrollable="true"
            scrollHeight="400px"
            class="p-mt-3 confirmation-table"
          >
            <Column
              field="code"
              header="Kode Barang"
              headerStyle="width: 10em; text-align: left"
            >
              <template #body="slotProps">
                <span class="truncate-cell" :title="slotProps.data.code">{{
                  slotProps.data.code
                }}</span>
              </template>
            </Column>
            <Column
              field="name"
              header="Nama Barang"
              headerStyle="width: 15em; text-align: left"
            >
              <template #body="slotProps">
                <span class="truncate-cell" :title="slotProps.data.name">{{
                  slotProps.data.name
                }}</span>
              </template>
            </Column>
            <Column
              field="sup_name"
              header="Supplier"
              headerStyle="width: 10em; text-align: left"
            >
              <template #body="slotProps">
                <span class="truncate-cell" :title="slotProps.data.sup_name">{{
                  slotProps.data.sup_name
                }}</span>
              </template>
            </Column>
            <Column
              field="cat_name"
              header="Kelompok"
              headerStyle="width: 10em; text-align: left"
            >
              <template #body="slotProps">
                <span class="truncate-cell" :title="slotProps.data.cat_name">{{
                  slotProps.data.cat_name
                }}</span>
              </template>
            </Column>
            <Column
              field="input_stok"
              header="Jumlah"
              headerStyle="width: 5em; text-align: center"
            >
              <template #body="slotProps">
                {{ slotProps.data.input_stok }}
              </template>
            </Column>
            <Column
              field="barcode_date"
              header="Tanggal"
              headerStyle="width: 8em; text-align: center"
            >
              <template #body>
                {{ moment(filter.barcode_date).format('DD/MM/YYYY') }}
              </template>
            </Column>
          </DataTable>
        </div>
        <template #footer>
          <Button
            label="Batal"
            icon="pi pi-times"
            class="p-button-text"
            @click="print_dialog = false"
          />
          <Button
            label="Cetak"
            icon="pi pi-check"
            class="p-button-primary"
            @click="saveClicked()"
            :loading="loading_ok"
          />
        </template>
      </Dialog>
    </div>
    <br />
    <div class="card css-table" v-if="confirmation_page == 1">
      <DataTable
        :value="list_request"
        :loading="loading.filter"
        :rowHover="true"
        :selection.sync="selectedItems"
        :paginator="true"
        :rows="15"
      >
        <template #empty>Data tidak tersedia.</template>
        <template #loading
          >Mengambil data daftar cetak barang. Mohon tunggu.</template
        >
        <h5>
          <b>Konfirmasi Cetak</b>
        </h5>

        <Column field="cat_no" header="No" headerStyle="width: 3em">
          <template #body="slotProps">
            {{ list_request.indexOf(slotProps.data) + 1 }}
          </template>
        </Column>
        <Column header="Id Barang">
          <template #body="slotProps">
            <span> {{ slotProps.data.id }} </span>
          </template>
        </Column>
        <Column header="Nama Barang">
          <template #body="slotProps">
            <span> {{ slotProps.data.name }} </span>
          </template>
        </Column>
        <Column header="Supplier" headerStyle="width: 14em;">
          <template #body="slotProps">
            <span> {{ slotProps.data.sup }} </span>
          </template>
        </Column>
        <Column header="Kelompok Barang">
          <template #body="slotProps">
            <span> {{ slotProps.data.cat_name }} </span>
          </template>
        </Column>
        <Column header="Tanggal Barcode">
          <template #body="slotProps">
            <span> {{ slotProps.data.barcode_date }} </span>
          </template>
        </Column>
        <Column header="Qty" headerStyle="width: 12em;">
          <template #body="slotProps">
            <span> {{ slotProps.data.qty }} </span>
          </template>
        </Column>
      </DataTable>

      <div class="p-grid p-justify-center p-mt-4">
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            class="btn btn-primary"
            @click="showDialogPrint()"
            style="width: 100%"
          >
            Cetak
          </button>
        </div>
      </div>

      <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
        <Dialog
          :visible.sync="print_dialog"
          :style="{ width: '450px' }"
          header="Confirmation Messages"
          :modal="true"
          class="p-fluid"
        >
          <div class="confirmation-content">
            <i class="pi pi-print p-mr-3" style="font-size: 1rem" />
            <span> Save untuk Mendownload Barcode </span>
          </div>
          <template #footer>
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              @click="print_dialog = false"
            />
            <Button
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveClicked()"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import { mapState } from 'vuex'
let moment = require('moment')

export default {
  computed: mapState(['user', 'isAuthenticated']),
  data() {
    return {
      moment: moment,
      today: new Date(),
      outlets: [],
      selected_outlet: '',

      loading: {
        filter: true
      },

      filter: {
        show_all: false,
        cat_code: '',
        supplier_value: true
      },

      input_stok: '',
      confirmation_page: 0,

      print_dialog: false,
      confirmation_dialog: false,

      suppliers: [],
      filtered_suppliers: [],
      selected_supplier: '',

      request_api: [],
      list_items: [],
      list_request: {
        id: '',
        qty: this.input_stok
      },

      loading_ok: false,

      warehouse_outbounds: [],
      selectedItems: [],
      selectedItems_id: '',
      ids: [],

      barcodes: null,

      is_error: {
        supplier: false,
        outlet: false
      },

      error_msg: {
        supplier: '',
        outlet: ''
      }
    }
  },

  mounted() {
    this.getSuppliers()
    this.getCatalogue()
  },

  methods: {
    showAll() {
      this.selected_supplier = ''
      this.filter.barcode_date = ''
      this.filter.doc_number = ''
      this.filter.doc_date = ''
    },

    getSuppliers() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`${process.env.VUE_APP_API_URL}/suppliers?limit=5`)
          .then(response => {
            if (response.status === 200) {
              this.suppliers = response.data.data.suppliers
              resolve()
            }
          })
          .catch(err => {
            console.error('Error : ', err)
            reject(err)
          })
      })
    },

    getCatalogue() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`${process.env.VUE_APP_API_URL}/warehouse-items?limit=10`)
          .then(response => {
            this.loading.filter = false
            if (response.status === 200) {
              this.list_items = response.data.data.items
              resolve()
            }
          })
          .catch(err => {
            console.error('Error : ', err)
            reject(err)
          })
      })
    },

    async searchSupplier(event) {
      try {
        let searchQuery =
          this.selected_supplier instanceof Object
            ? this.selected_supplier.name
            : this.selected_supplier
            ? this.selected_supplier
            : ''

        let response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/suppliers?search=${searchQuery}&limit=5`
        )

        if (response.status === 200) {
          this.suppliers = response.data.data.suppliers
        }

        this.filtered_suppliers = this.suppliers.filter(item => {
          return (
            item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
            item.code.toLowerCase().startsWith(event.query.toLowerCase())
          )
        })
      } catch (error) {
        console.error('Error fetching suppliers:', error)
      }
    },

    async filterCatalogue() {
      this.loading.filter = true
      let filtered_code = this.filter.mutation_code
        ? this.filter.mutation_code
        : ''
      let supplier_id = this.selected_supplier.id
        ? this.selected_supplier.id
        : ''

      try {
        let response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?limit=10&supplier_id=${supplier_id}&code=${filtered_code}`
        )

        if (response.status === 200) {
          this.list_items = response.data.data.items
        }
      } catch (error) {
        console.error('Error fetching catalogue:', error)
      } finally {
        this.loading.filter = false
      }
    },

    saveClicked() {
      this.loading_ok = true
      let itemsArray = []

      const date =
        this.filter.barcode_date instanceof Date
          ? moment(this.filter.barcode_date).format('YYYY-MM-DD')
          : ''

      for (let i = 0; i < this.selectedItems.length; i++) {
        let item = this.selectedItems[i]
        let request_api = {
          id: item.id,
          qty: parseInt(item.input_stok) || 0,
          barcode_date: date
        }
        itemsArray.push(request_api)
      }

      let requestBody = {
        items: itemsArray
      }

      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/printed-barcode/request`,
          requestBody
        )
        .then(response => {
          if (response.status === 200) {
            this.barcodes = response.data.data.barcodes
            let file = new Blob([this.barcodes], {
              type: 'text/plain;charset=utf-8'
            })
            saveAs(file, 'barcodes.txt')
            this.print_dialog = false
            this.showToast('success', 'Sukses', 'Barcode berhasil dicetak')
          } else {
            this.showToast('error', 'Error', 'Gagal mencetak barcode')
          }
        })
        .catch(error => {
          console.error('Error printing barcode:', error)
          this.showToast('error', 'Error', 'Gagal mencetak barcode')
        })
        .finally(() => {
          this.loading_ok = false
        })
    },

    showDialogPrint() {
      this.print_dialog = true
    },

    confirmationPage() {
      this.confirmation_dialog = 1
    },

    printBarcode() {
      // Validate stock before showing dialog
      for (let i = 0; i < this.selectedItems.length; i++) {
        if (this.selectedItems[i].input_stok > this.selectedItems[i].stock) {
          this.showToast('error', 'Error', 'Stok tidak mencukupi')
          return
        }
      }
      this.print_dialog = true
    },

    onReset() {
      this.selected_supplier = ''
      this.filter.mutation_code = ''
      this.filter.barcode_date = null
      this.filterCatalogue()
    },

    showToast(severity, summary, detail) {
      this.$toast.add({
        severity: severity,
        summary: summary,
        detail: detail,
        life: 3000
      })
    }
  }
}
</script>

<style scoped lang="scss">
.truncate-cell {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  width: 100%;
}

:deep(.confirmation-table) {
  .p-datatable-tbody > tr > td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;
  }

  .p-datatable-thead > tr > th {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
